

import { CForm, CButton, CTooltip, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CFormLabel, CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem } from '@coreui/react'
import React, { useEffect, useRef, useState } from 'react'
import LabDisplayComponent from './LabDisplayComponent'
import FinalNoteDisplayImaging from './FinalNoteDisplayImaging'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import { Info, Pencil, Trash2 } from 'lucide-react'
import { CSpinner } from '@coreui/react'
import AsseseementFinalNote from './Asseseement'
import PatientQuestionPoa from './PatientQuestionPoa'
import PatientTreatmentsPlans from './PatientTreatmentsPlans'
import PatientRisk from './PatientRisk'
import PatientDifferentialDiagnosis from './PatientDifferentialDiagnosis'
import MultiSelect from '../../components/shared/MultiSelect'
import MorseBimsScore from '../../components/shared/MorseBimsScore'
import MorseScore from '../../components/shared/MorseScore'
import MobilityAssessment from '../../components/shared/MobilityAssessment'
import SelfCareAssessment from './SelfCareAssessment'
import FallsAssessment from '../../components/shared/FallsAssessment'
import HPIQuestions from './HPIQuestions'
import PatientIncidet from './PatientIncidet'
import PatientAlerts from './PatientAlerts'
import ReviewOfSystem from './ReviewOfSystem'
import SaveExtra from '../../../src/services/general/saveExtraData.api'
import PhysicalExaminationVisualNote from './PhysicalExaminationVisualNote'
import IncidentHqFinalNote from './IncidentHqFinalNote'
import PatientHistoryofdiagnosis from './PatientHistoryofdiagnosis'
import renderHighlightedText from './renderHighlightedText'
import Loader from '../../components/shared/Loader'
const Note = ({
  patientID,
  targetRef,
  selectedRisks,
  isAllotedToProvider,
  saveTreatsShell,
  vitalsList,
  statusPatientNote,
  setSelectedRisks,
  diagnosisCode,
  allLabs,
  toPDF,
  MasterDiagnosisData,
  patientData,
  newmedsAdded,
  newLabsAdded,
  newImagingAdded,
  imagingTypeList,
  noteStructureRef,
  patientTreatments,
  GetMasterMedications,
  masterMedications,
  setMasterMedications,
  hospitalRecords,
  setHospitalRecords,
  diagnosisAddedPinger,
  patientSidebarActiveTab,
  allergies,
  patientDiagnosis,
  setAllergies,
  personalHistory,
  setPersonalHistory,
  medication,
  setMedication,
  imaging,
  setImaging,
  activeTab,
  selectedDifferentialDiagnosis,
  setSelectedDifferentialDiagnosis,
  showComment,
  noteID,
  updatePatientDiagnosis,
  editPatientDiagnosis,
  deletePatientDiagnosis,
  updateNoteStructure,
  setUpdatePE,
  saveTreatsShellForHospitalRecord,
  updatePE,
  appointments,
  UpdateCheckForStatusData,
  loading,
  setLoading }) => {
  const [riskfactors, setRiskFactors] = useState({})
  const [patientDifferentialDiagnosis, setSelectedPatientDifferentialDiagnosis] = useState({})
  const [riskFactorWithKeyword, setRiskFactorsWithKeyword] = useState({})
  const [diagnosisLabMap, setDiagnosisLabMap] = useState({})
  const [diagnosisOptions, setDiagnosisOptions] = useState([])
  const [selectedDiagnosis, setSelectedDiagnosis] = useState(null)
  const [editDiagnosis, setEditDiagnosis] = useState(null)
  const [deleteVisible, setDeleteVisible] = useState(false)
  const [questionValue, setQuestionsValue] = useState([])
  const [noteRefTrigger, setNoteRefTrigger] = useState(0)
  const [addedNewIncident, setAddedNewIncident] = useState(false)
  const showDataIfNoteIsFollowUp = statusPatientNote === 'Follow Up' ? true : false // not showing data if note is follow up
  const [visible, setVisible] = useState(false)
  const [loadingLabs, setLoadingLabs] = useState(false)
  const [loadingRisks, setLoadingRisks] = useState(false)
  const [loadingDifferential, setLoadingDifferential] = useState(false)
  const [loadingHospitalRecords, setLoadingHospitalRecords] = useState(false)
  const [processedHospitalRecords, setProcessedHospitalRecords] = useState([])
  const [isFinalNoteLoading, setIsFinalNoteLoading] = useState(true)

  const vitalFields = {
    BloodPressure: { label: 'Blood Pressure', unit: 'mmHg' },
    HeartRate: { label: 'Heart Rate', unit: 'bpm' },
    RespiratoryRate: { label: 'Respiratory Rate', unit: 'rpm' },
    Temperature: { label: 'Temperature', unit: '°F' },
    SpO2: { label: 'SpO2', unit: '%' },
    InhaledO2: { label: 'Inhaled O2', unit: '%' },
    HeartCirc: { label: 'Heart Circ', unit: 'in' },
    Height: { label: 'Height', unit: 'ft/in' },
    Weight: { label: 'Weight', unit: 'lbs/oz' },
  }



  useEffect(() => {
    console.log(noteStructureRef.current, "FinalNoteLog")
  }
    , [])

  const getLabs = () => {
    setLoadingLabs(true)

    try {
      let noteLabs = localStorage.getItem('notesLabs')
      let labs = JSON.parse(noteLabs)

      if (labs) {
        let diagnosisMap = filterLabsByDiagnosis(labs)
        setDiagnosisLabMap(diagnosisMap)
      }
    } catch (e) {
      console.error('Error parsing labs:', e)
    } finally {
      setLoadingLabs(false)
    }
  }
  const normalizeHighlights = (highlights = []) => {
    const validHighlights = (highlights || [])
      .filter((h) => h && typeof h.start === 'number' && typeof h.end === 'number' && h.start < h.end)
      .map((h) => ({
        ...h,
        start: Math.max(0, h.start),
        end: Math.max(h.start, h.end),
      }))

    if (!validHighlights.length) return []

    const mergedHighlights = []
    validHighlights
      .sort((a, b) => a.start - b.start)
      .forEach((highlight) => {
        const last = mergedHighlights[mergedHighlights.length - 1]
        if (!last || highlight.start > last.end) {
          mergedHighlights.push({ ...highlight })
        } else {
          last.end = Math.max(last.end, highlight.end)
        }
      })

    return mergedHighlights
  }

  const renderHighlightedTextHistory = (text = '', highlights = []) => {
    if (!text) return null

    const objectHighlights = normalizeHighlights(highlights)
    if (!objectHighlights.length) return <span>{text}</span>

    const parts = []
    let lastIndex = 0

    objectHighlights.forEach((h, i) => {
      const start = Math.max(h.start, lastIndex)
      const end = Math.min(h.end, text.length)

      if (start > lastIndex) {
        parts.push(<span key={`text-${i}`}>{text.slice(lastIndex, start)}</span>)
      }

      parts.push(
        <span key={`highlight-${i}`} style={{ color: 'orange', fontWeight: 600 }}>
          {text.slice(start, end)}
        </span>,
      )

      lastIndex = end
    })

    if (lastIndex < text.length) {
      parts.push(<span key="end">{text.slice(lastIndex)}</span>)
    }

    return <>{parts}</>
  }

  const getRisks = async (diagnosisList) => {
    setLoadingRisks(true)

    try {
      let responseRisks = await GetDiagnosisData('Risks')

      let risks = JSON.parse(responseRisks.d)?.Data

      let riskFactorsWithKeywordss = {}
      let allRisks = {}

      diagnosisList.forEach((diagnosis) => {
        let riskObj = risks.find(
          (obj) => obj.Name.trim() == diagnosis.trim()
        )

        if (riskObj) {
          riskFactorsWithKeywordss[diagnosis] = JSON.parse(
            riskObj?.RiskFactors1
          )
        } else {
          riskFactorsWithKeywordss[diagnosis] = []
        }
      })

      setRiskFactorsWithKeyword(riskFactorsWithKeywordss)

      diagnosisList.forEach((diagnosis) => {
        let riskObj = risks.find(
          (obj) => obj.Name.trim() == diagnosis.trim()
        )

        if (riskObj) {
          allRisks[diagnosis] = riskObj.RiskFactors.split(',')
        } else {
          allRisks[diagnosis] = []
        }
      })

      setRiskFactors(allRisks)
    } catch (e) {
      console.error('Failed to parse risks', e)
    } finally {
      setLoadingRisks(false)
    }
  }

  const getDifferentialDiagnosis = async (diagnosisList) => {
    setLoadingDifferential(true)

    try {
      let responseDifferentialDiagnosis =
        JSON.parse(localStorage.getItem('DifferentialDiagnosis')) || []

      let allDifferentialDiagnosis = {}

      diagnosisList.forEach((diagnosis) => {
        let DdObj = responseDifferentialDiagnosis.find(
          (obj) => obj.Name.trim() == diagnosis.trim()
        )

        if (DdObj) {
          allDifferentialDiagnosis[diagnosis] =
            DdObj.DifferentialDiagnosis.split(',')
        } else {
          allDifferentialDiagnosis[diagnosis] = []
        }
      })

      setSelectedPatientDifferentialDiagnosis(allDifferentialDiagnosis)
    } catch (e) {
      console.error('Failed to parse differential diagnosis', e)
    } finally {
      setLoadingDifferential(false)
    }
  }

  const formData = useRef([])

  const filterEmptyAnswers = (data) => {
    return data
      .filter((item) => typeof item === 'object' && !Array.isArray(item))
      .map((item) => {
        return {
          ...item,
          data: Object.fromEntries(Object.entries(item.data).filter(([key, value]) => value !== '')),
        }
      })
  }

  const [newComponents, setNewComponents] = useState([])
  const [loadingPoa, setLoadingPoa] = useState(false)


  const getLatestNoteByPatientAndNoteID = (allPatientHpiData, patientID) => {
    const filtered = allPatientHpiData.filter((item) => {
      const patientData = item[patientID]
      // /  return patientData && patientData[noteID]
      return patientData
    })

    const latest = filtered.at(-1)
    return latest || null
  }

  const [freeTypeGlobal, setFreeTypeGlobal] = useState('')
  const getCallCenterData = async (diagnosisList) => {
    setLoadingPoa(true)

    let data = await SaveExtra('Get_By_Type', 'CallCenterQuestions', '', '')
    let allData = JSON.parse(data?.d)

    const allPatientHpiData = allData?.Data?.map((item) => {
      return {
        ...JSON.parse(item?.JsonData),
        CreatedAt: item?.CreatedAt,
      }
    })

    const result = getLatestNoteByPatientAndNoteID(allPatientHpiData, patientID)
    const convertedData = {}
    const callCenterData = result?.[patientID]?.CCENTER
    const globalFreeType = result?.[patientID]?.globalFreeType

    if (callCenterData) {
      Object.keys(callCenterData).forEach((diagnosis) => {
        convertedData[diagnosis] = callCenterData[diagnosis]?.map((q) => ({
          question: q.label,
          answer: q.answer,
          freeType: q.freeType,
          type: q?.type,
          freewayRemark: q?.freewayRemark,
        }))
      })
    }

    setFreeTypeGlobal(globalFreeType)
    setQuestionsValue(convertedData)
    setLoadingPoa(false)

    return convertedData
  }

  const DiagnosisOptions = async () => {
    try {
      let response = await GetDiagnosisData('')
      let diagnosis = JSON.parse(response.d)?.Data
      const options = diagnosis.map((item) => ({
        value: item.id,
        label: item.Name,
      }))
      setDiagnosisOptions(options)
    } catch (error) {
      console.error('Error updating diagnosis options:', error)
    }
  }
  useEffect(() => {
    let isMounted = true

    const loadFinalNoteData = async () => {
      setIsFinalNoteLoading(true)

      try {
        await Promise.all([
          getCallCenterData(patientDiagnosis),
          Promise.resolve(getLabs()),
          getRisks(patientDiagnosis),
          getDifferentialDiagnosis(patientDiagnosis),
          DiagnosisOptions(),
          getTreatmentPlansData(),
        ])
      } catch (error) {
        console.error('Error loading final note data:', error)
      } finally {
        if (isMounted) {
          setIsFinalNoteLoading(false)
        }
      }
    }

    loadFinalNoteData()

    return () => {
      isMounted = false
    }
  }, [diagnosisAddedPinger, patientDiagnosis, patientID])

  const historyMapping = {
    pmhx: 'Past Medical History',
    pshx: 'Past Surgical History',
    fh: 'Family History',
    sh: 'Social History',
  }

  const historyObjectKeysParticular = {
    pmhx: 'MedicalHistory',
    pshx: 'SurgicalHistory',
    fh: 'FamilyHistory',
    sh: 'SocialHistory',
  }

  const getFormattedDate = () => {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
    const yyyy = today.getFullYear()
    const hh = String(today.getHours()).padStart(2, '0')
    const min = String(today.getMinutes()).padStart(2, '0')
    return `${mm}.${dd}.${yyyy} ${hh}:${min}`
  }

  const getDiagnosisMedicationInRisk = (diagnosisName) => {
    if (masterMedications.length > 0) {
      const lastMedicationAdded = medication[medication.length - 1]
      if (!lastMedicationAdded) return
      const { data } = lastMedicationAdded
      const matchingDiagnoses = data.map((med) => {
        const matchingMasterMed = masterMedications.find((item) => item.Data.name === med.name)
        return matchingMasterMed
      })
      let name
      matchingDiagnoses.find((item) => {
        if (item?.Data.diagnoses.includes(diagnosisName)) {
          name = item.Data
        }
      })
      return name
    } else {
      return 'Not enough information'
    }
  }

  const hasAnyAnswer = (data) => {
    return Object.values(data).some((value) => {
      return typeof value === 'string' && value.trim() !== ''
    })
  }

  const handleSaveDiagnosis = () => {
    editPatientDiagnosis(patientID, editDiagnosis, selectedDiagnosis.label)
    setVisible(false)
    setEditDiagnosis(null)
  }
  const handleDeleteDiagnosis = () => {
    deletePatientDiagnosis(patientID, editDiagnosis)
    setEditDiagnosis(null)
    setDeleteVisible(false)
  }

  const [allTreamentStatements, setAllTreatmentStatements] = useState([])
  const getTreatmentPlansData = async () => {
    let data = await SaveExtra('Get_By_Type', 'generalPlanStatements', '', '')
    data = JSON.parse(data.d)?.Data || []
    if (data) {
      data = data?.map((item) => {
        return {
          Id: item.Id,
          Data: JSON.parse(item?.JsonData),
        }
      })
    }
    setAllTreatmentStatements(data)
  }

  useEffect(() => {
    if (patientTreatments[noteID]?.data?.riskFactors) {
      setSelectedRisks(patientTreatments[noteID].data.riskFactors || {})
    }
  }, [])

  const selectedRecords = hospitalRecords.filter((item) => item.Id === noteStructureRef.current?.metadata?.historyId)

  const finalRecords = selectedRecords.length > 0 ? selectedRecords : hospitalRecords.length > 0 ? [hospitalRecords[hospitalRecords.length - 1]] : []

  const resolveTooltipContent = (obj, info) => {
    const sources = new Set()

    if (info) {
      const infoArray = Array.isArray(info) ? info : [info]
      infoArray.forEach((item) => {
        if (!item) return
        const trimmed = item.trim()
        if (trimmed === 'Patient History') {
          sources.add('History')
        } else if (trimmed === 'Hospital Records') {
          sources.add('Hospital Records')
        } else if (trimmed === 'Patient Added') {
          sources.add('Back Office Added')
        } else if (trimmed === 'Provider Added') {
          sources.add('Provider Added')
        } else if (trimmed.startsWith('Imaging(') && trimmed.endsWith(')')) {
          const imagingName = trimmed.substring(8, trimmed.length - 1)
          sources.add(`Imaging (${imagingName})`)
        } else if (trimmed.startsWith('Labs(') && trimmed.endsWith(')')) {
          const labName = trimmed.substring(5, trimmed.length - 1)
          sources.add(`Labs (${labName})`)
        } else {
          sources.add(trimmed)
        }
      })
    }

    const carriedForwardSources = Array.from(sources)
    if (carriedForwardSources.includes('Carry Forwarded from Previous Note')) {
      return carriedForwardSources.join(', ')
    }

    const diagLower = obj.toLowerCase()

    // 1. Dynamic check for Histories (Personal History)
    if (personalHistory) {
      const historyTypes = ['pmhx', 'pshx', 'fh', 'sh']
      const historyKeys = {
        pmhx: 'MedicalHistory',
        pshx: 'SurgicalHistory',
        fh: 'FamilyHistory',
        sh: 'SocialHistory'
      }
      historyTypes.forEach((type) => {
        const key = historyKeys[type]
        const records = personalHistory[type] || []
        records.forEach((record) => {
          const historyText = (record[key] || '').toLowerCase()
          let isMatch = historyText.includes(diagLower)

          if (!isMatch) {
            const abbreviations = {
              'multiple sclerosis': ['ms'],
              'cva': ['cva', 'stroke'],
              'atrial fibrillation': ['afib', 'a-fib', 'a.fib'],
              'cognitive communication deficit': ['ccd'],
              'alcohol abuse': ['etoh', 'alcohol'],
              'falls': ['fall', 'falls'],
              'parkinson\'s disease': ['parkinson', 'parkinsons', 'pd'],
              'myasthenia gravis': ['mg']
            }
            const mappedAbbrevs = abbreviations[diagLower] || []
            for (const abbrev of mappedAbbrevs) {
              const regex = new RegExp(`\\b${abbrev}\\b`, 'i')
              if (regex.test(historyText)) {
                isMatch = true
                break
              }
            }
          }

          if (isMatch) {
            sources.add('History')
          }
        })
      })
    }

    // 2. Dynamic check for Hospital Records
    if (Array.isArray(hospitalRecords)) {
      hospitalRecords.forEach((record) => {
        const historyText = (record.History || '').toLowerCase()
        let isMatch = historyText.includes(diagLower)

        if (!isMatch) {
          const abbreviations = {
            'multiple sclerosis': ['ms'],
            'cva': ['cva', 'stroke'],
            'atrial fibrillation': ['afib', 'a-fib', 'a.fib'],
            'cognitive communication deficit': ['ccd'],
            'alcohol abuse': ['etoh', 'alcohol'],
            'falls': ['fall', 'falls'],
            'parkinson\'s disease': ['parkinson', 'parkinsons', 'pd'],
            'myasthenia gravis': ['mg']
          }
          const mappedAbbrevs = abbreviations[diagLower] || []
          for (const abbrev of mappedAbbrevs) {
            const regex = new RegExp(`\\b${abbrev}\\b`, 'i')
            if (regex.test(historyText)) {
              isMatch = true
              break
            }
          }
        }

        if (isMatch) {
          sources.add('Hospital Records')
        }
      })
    }

    // 3. Dynamic check for Labs
    if (Array.isArray(allLabs)) {
      allLabs.forEach((lab) => {
        if (Array.isArray(lab.data)) {
          lab.data.forEach((item) => {
            const diagList = (item.diagnosis || '').split(',').map((d) => d.trim().toLowerCase())
            if (diagList.includes(diagLower)) {
              sources.add(`Labs (${item.name})`)
            }
          })
        }
      })
    }

    // 4. Dynamic check for Imaging
    if (Array.isArray(imaging)) {
      imaging.forEach((img) => {
        const impression = (img.data?.impression || '').toLowerCase()
        let isMatch = impression.includes(diagLower)

        if (!isMatch) {
          const abbreviations = {
            'multiple sclerosis': ['ms'],
            'cva': ['cva', 'stroke'],
            'atrial fibrillation': ['afib', 'a-fib', 'a.fib'],
            'cognitive communication deficit': ['ccd'],
            'alcohol abuse': ['etoh', 'alcohol'],
            'falls': ['fall', 'falls'],
            'parkinson\'s disease': ['parkinson', 'parkinsons', 'pd'],
            'myasthenia gravis': ['mg']
          }
          const mappedAbbrevs = abbreviations[diagLower] || []
          for (const abbrev of mappedAbbrevs) {
            const regex = new RegExp(`\\b${abbrev}\\b`, 'i')
            if (regex.test(impression)) {
              isMatch = true
              break
            }
          }
        }

        if (!isMatch) {
          const words = diagLower.split(/\s+/).filter(w => w.length > 3)
          if (words.length > 0 && words.every(w => impression.includes(w))) {
            isMatch = true
          }
        }

        if (isMatch) {
          sources.add(`Imaging (${img.data?.name || img.name})`)
        }
      })
    }

    const resultList = Array.from(sources)
    if (resultList.length > 1 && (resultList.includes('Back Office Added') || resultList.includes('Patient Added'))) {
      const filtered = resultList.filter((s) => s !== 'Back Office Added' && s !== 'Patient Added')
      if (filtered.length > 0) return filtered.join(', ')
    }

    return resultList.length > 0 ? resultList.join(', ') : 'Back Office Added'
  }

  if (isFinalNoteLoading) {
    return (
      <div style={{ minHeight: '70vh' }}>
        <Loader height="70vh" />
      </div>
    )
  }

  return (
    <div className="mt-4 d-flex flex-column p-8">
      <div ref={targetRef}>
        {/* Hospital Records */}
        <div className="card mb-4 p-3">
          <h6 className="fs-7 text-primary" style={{ color: '#808080', opacity: '0.8' }}>
            Hospital Records
          </h6>

          {loadingHospitalRecords ? (
            <div className="d-flex justify-content-center align-items-center p-3">
              <CSpinner color="primary" />
            </div>
          ) : (
            <CForm>
              {/* {processedHospitalRecords.map((record, index) => (
        <div
          key={record.Id || index}
          style={{ whiteSpace: 'pre-line' }}
        >
          {renderHighlightedTextHistory(
            record?.History,
            noteStructureRef.current?.highlightDetails?.[record?.Id] || []
          )}
        </div>
      ))} */}

              {hospitalRecords
                .filter((item) => item.Id === noteStructureRef.current?.metadata?.historyId)
                .map((record, index) => {
                  const rows = Math.max(4, Math.ceil(record.History.length / 50))
                  return (
                    <>
                      <div suppressContentEditableWarning={true} className="my-1" style={{ whiteSpace: 'pre-line' }}>
                        {/* <Highlighter
                        textToHighlight={record.History || ""}
                        highlightClassName="your-highlight-class"
                        highlightStyle={{ color: 'orange', background: "inherit" }}
                        searchWords={noteStructureRef.current?.highlightDetails?.[record?.Id] || []}
                      /> */}

                        {renderHighlightedTextHistory(record?.History, noteStructureRef.current?.highlightDetails?.[record?.Id] || [])}
                      </div>
                    </>
                  )
                })}
            </CForm>
          )}
        </div>

        {/* History */}
        {/* not showing the histories and allergies in final note when note is followup */}
        {statusPatientNote !== 'Follow Up' && (
          <div className="card mb-4 p-3">
            <h6 className="fs-7 text-primary" style={{ color: '#808080', opacity: '0.8' }}>
              History
            </h6>
            <CForm>
              {Object.entries(personalHistory).map(([key, histories], index) => {
                return (
                  histories.length > 0 && (
                    <div key={index} className="mt-2">
                      <p className="fw-bold" style={{ color: '#808080' }}>
                        {historyMapping[key]}
                      </p>
                      {histories
                        .filter((item) => item.Id === noteStructureRef?.current?.metadata?.[historyObjectKeysParticular[key]])
                        .map((item, index) => (
                          <div key={index} suppressContentEditableWarning={true} style={{ whiteSpace: 'pre-line' }} className="px-4">
                            {item[historyObjectKeysParticular[key]]}
                          </div>
                        ))}
                    </div>
                  )
                )
              })}
            </CForm>
          </div>
        )}

        {/* Vitals */}
        <div className="card mb-4 p-3">
          <h6 className="fs-7 text-primary" style={{ color: '#808080', opacity: '0.8' }}>
            Vitals
          </h6>

          <div>
            {vitalsList?.slice(-1).map((item, index) => {
              return (
                <div key={index}>
                  {Object.entries(item).map(([key, value]) => {
                    if (key === 'Remarks' || key === 'ID' || key === 'PatientID') return null

                    // Format Date
                    if (key === 'Date') {
                      const dateObj = new Date(value)
                      const formattedDate = `${String(dateObj?.getMonth() + 1).padStart(2, '0')}/${String(dateObj?.getDate()).padStart(2, '0')}/${dateObj?.getFullYear()}`

                      return (
                        <div key={key} style={{ marginBottom: '0.5rem' }}>
                          <strong>Date:</strong> {formattedDate}
                        </div>
                      )
                    }

                    return (
                      <div key={key} style={{ marginBottom: '0.5rem' }}>
                        <strong>{key.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase())}:</strong> {value} {vitalFields[key]?.unit}
                      </div>
                    )
                  })}
                </div>
              )
            })}
          </div>
        </div>

        {/* Allergies */}
        {/* not showing the histories and allergies in final note when note is followup */}

        <div className="card mb-4 p-3">
          <h6 className="fs-7 text-primary" style={{ color: '#808080', opacity: '0.8' }}>
            Allergy
          </h6>
          <CForm>
            {allergies.length > 0 &&
              allergies
                .filter((item) => noteStructureRef?.current?.metadata?.allergiesIds?.includes(item.id))
                .map((item, idx) => (
                  <div key={idx} className="   mb-2">
                    <p suppressContentEditableWarning={true} className="m-0" style={{ fontWeight: '600' }}>
                      Allergy: {item.data?.allergen}
                    </p>
                    <p suppressContentEditableWarning={true} className="m-0" style={{ fontWeight: '600' }}>
                      Severity: {item.data?.severity}
                    </p>
                    <p suppressContentEditableWarning={true} className="text-warning m-0">
                      Reaction: {item.data?.reaction}
                    </p>
                  </div>
                ))}
          </CForm>
        </div>

        {/* Medications */}
        {/* <div className='card mb-4 p-3'>
                    <h6 className='fs-7 text-primary' style={{ color: "#808080", opacity: "0.8" }}>Medications</h6>
                    <CForm>
                        {medication.length > 0 && (
                            <div className='flex flex-column gap-3'>
                                {medication[0].data.map((items, idx) => (
                                    // {medication[medication.length - 1].data.map((items, idx) => (
                                    <div key={idx} className='d-flex align-items-center gap-2'>
                                        <p contentEditable suppressContentEditableWarning={true} className='m-0'>
                                            <b>Date:</b> {new Date(medication[medication.length - 1].date).toLocaleDateString('en-US',{
                                                month: '2-digit',
                                                day: '2-digit',
                                                year: 'numeric'
                                            })}
                                        </p>
                                        <p contentEditable suppressContentEditableWarning={true} className='m-0'>
                                            <b>Name:</b> {items.name}
                                        </p>
                                        <p contentEditable suppressContentEditableWarning={true} className='m-0'>
                                            <b>Dosage:</b> {items.dosage}
                                        </p>
                                        <p contentEditable suppressContentEditableWarning={true} className='m-0'>
                                            <b>Route:</b> {items.route}
                                        </p>
                                        <p contentEditable suppressContentEditableWarning={true} className='m-0'>
                                            <b>Frequency:</b> {items.frequency}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        )}
                    </CForm>
                </div> */}

        {/* Medications */}
        {/* {medication.length > 0 && (() => {
                    const selectedMedication = medication.find(item => item.id === noteStructureRef.current?.metadata?.medId);
                    return (
                        <div className='card mb-4 p-3'>
                            <h6 className='fs-7 text-primary' style={{ color: "#808080", opacity: "0.8" }}>Medications</h6>
                            <CForm>
                                <div className='flex flex-column gap-3'>
                                    {selectedMedication?.data?.map((items, idx) => (
                                        <div key={idx} className='d-flex align-items-center gap-2'>
                                            <p contentEditable suppressContentEditableWarning={true} className='m-0'>
                                                <b>Name:</b> {items.name}
                                            </p>
                                            <p contentEditable suppressContentEditableWarning={true} className='m-0'>
                                                <b>Dosage:</b> {items.dosage}
                                            </p>
                                            <p contentEditable suppressContentEditableWarning={true} className='m-0'>
                                                <b>Route:</b> {items.route}
                                            </p>
                                            <p contentEditable suppressContentEditableWarning={true} className='m-0'>
                                                <b>Frequency:</b> {items.frequency}
                                            </p>
                                        </div>
                                    ))}
                                </div>
                            </CForm>
                        </div>
                    );
                })()} */}
        {/* Medications */}
        {(() => {
          const selectedMedication = medication.find((item) => item.id === noteStructureRef.current?.metadata?.medId)

          return (
            <div className="card mb-4 p-3">
              <h6 className="fs-7 text-primary" style={{ color: '#808080', opacity: '0.8' }}>
                Medications
              </h6>
              <CForm>
                <div className="flex flex-column gap-3">
                  {
                    selectedMedication?.data?.length > 0
                      ? selectedMedication.data.map((items, idx) => (
                        <div key={idx} className="d-flex align-items-center gap-2">
                          <p suppressContentEditableWarning={true} className="m-0">
                            <b>Name:</b> {items.name}
                          </p>
                          <p suppressContentEditableWarning={true} className="m-0">
                            <b>Dosage:</b> {items.dosage}
                          </p>
                          <p suppressContentEditableWarning={true} className="m-0">
                            <b>Route:</b> {items.route}
                          </p>
                          <p suppressContentEditableWarning={true} className="m-0">
                            <b>Frequency:</b> {items.frequency}
                          </p>
                        </div>
                      ))
                      : ''
                    // <p className="text-muted m-0">No medications available</p>
                  }
                </div>
              </CForm>
            </div>
          )
        })()}

        <div className="card mb-4 p-3">
          <HPIQuestions isAllotedToProvider={isAllotedToProvider} patientDiagnosis={patientDiagnosis} diagnosis={patientDiagnosis} noteID={noteID} showDataIfNoteIsFollowUp={patientData?.Status === 'Follow Up' ? true : false} patientID={patientID} />
        </div>

        <div className="card mb-4 p-3">
          <ReviewOfSystem isAllotedToProvider={isAllotedToProvider} noteStructureRef={noteStructureRef} />
        </div>

        <PhysicalExaminationVisualNote noteID={noteID} saveTreatsShell={saveTreatsShell} isAllotedToProvider={isAllotedToProvider} patientID={patientID} showDataIfNoteIsFollowUp={showDataIfNoteIsFollowUp} noteStructureRef={noteStructureRef} setUpdatePE={setUpdatePE} updatePE={updatePE} />

        <IncidentHqFinalNote setAddedNewIncident={setAddedNewIncident} saveTreatsShell={saveTreatsShell} isAllotedToProvider={true} patientID={patientID} showDataIfNoteIsFollowUp={showDataIfNoteIsFollowUp} noteStructureRef={noteStructureRef} appointments={appointments} UpdateCheckForStatusData={UpdateCheckForStatusData} />

        {/* Labs */}
        {/* Labs */}
        <div className="card mb-4 p-3">
          <h6 className="fs-7 text-primary" style={{ color: '#808080', opacity: '0.8' }}>
            Labs
          </h6>

          {loadingLabs ? (
            <div className="d-flex justify-content-center align-items-center p-3">
              <CSpinner color="primary" />
            </div>

          ) : (
            <div className="d-flex flex-column gap-3">
              {allLabs.length > 0 &&
                allLabs
                  .filter(
                    (item) =>
                      Array.isArray(noteStructureRef.current?.metadata?.labId) &&
                      noteStructureRef.current.metadata.labId.includes(item.id)
                  )
                  .map((obj, idx) => (
                    <div key={idx}>
                      <p className="p-0 m-0">
                        {new Date(obj?.date).toLocaleDateString('en-US', {
                          month: '2-digit',
                          day: '2-digit',
                          year: 'numeric',
                        })}
                      </p>

                      <div>
                        {obj.data?.map((item, index) => {
                          const value = item.value ? parseFloat(item.value) : null
                          const rangeParts = item.range
                            ? item.range.split('-').map((part) => parseFloat(part.trim()))
                            : []

                          const isValueInRange =
                            value !== null &&
                            rangeParts.length === 2 &&
                            value >= rangeParts[0] &&
                            value <= rangeParts[1]

                          return (
                            <div key={index} className="d-flex gap-1 p-0 m-0">
                              <p className="p-0 m-0">{item.name}</p>
                              <p
                                style={{
                                  color: isValueInRange ? 'black' : 'orange',
                                }}
                                className="p-0 m-0"
                              >
                                {item.value}
                              </p>
                              <p className="p-0 m-0">{item.unit}</p>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  ))}

              {allLabs.length === 0 && (
                <p className="text-muted text-center m-0"></p>
              )}
            </div>
          )}
        </div>

        {/* Imaging */}
        <div className="card mb-4 p-3">
          <h6 className="fs-7 text-primary" style={{ color: '#808080', opacity: '0.8' }}>
            Imaging
          </h6>
          <CForm>
            {imaging.length > 0 &&
              imaging
                ?.filter((item) => noteStructureRef.current?.metadata?.imagingIds?.includes(item.id))
                ?.map((obj, idx) => {
                  return (
                    <div key={idx} className="mb-3">
                      <b suppressContentEditableWarning={true}>
                        {new Date(obj?.date).toLocaleDateString('en-US', {
                          month: '2-digit',
                          day: '2-digit',
                          year: 'numeric',
                        })}
                        : {obj.data?.name}
                      </b>
                      <p suppressContentEditableWarning={true}>
                        {/* {obj?.data?.impression && (
                          <Highlighter
                            highlightClassName="YourHighlightClass"
//added by mihir
                                                highlightStyle={{  backgroundColor: "white",color: 'orange', background: "inherit" }}
                            // searchWords={["and", "or", "the","dog is chasing"]}
                            autoEscape={true}
                            textToHighlight={obj?.data?.impression}
                            searchWords={obj?.data?.selectedText || []}
                          // textToHighlight="The dog is chasing the cat. Or perhaps they're just playing?"
                          />
                        )} */}
                        {/* <HighlightedText text={obj.data?.impression} keywords={obj.data?.keywords}></HighlightedText> */}
                        {/* <HighlightedTextImaging text={obj.data?.impression} keywords={obj.data?.keywords}></HighlightedTextImaging> */}
                        {renderHighlightedText(obj.data?.impression, obj.data?.selectedText || [])}
                        {showComment && obj?.data?.comment}
                      </p>
                    </div>
                  )
                })}
          </CForm>
        </div>

        <div className="card mb-4 p-3">
          <h6 className="fs-7 text-primary" style={{ color: '#808080', opacity: '0.8' }}>
            ASSESSMENT/PLAN
          </h6>
          {freeTypeGlobal && <div>{freeTypeGlobal} </div>}
          <CAccordion className="mt-2">
            {patientDiagnosis
              .filter((item) => item !== '')
              .map((obj, i) => {
                // let info = noteStructureRef?.current?.information?.find(item => item.diagnosis === obj);
                let info = noteStructureRef?.current?.information?.[obj]

                return (
                  <CAccordionItem>
                    <CAccordionHeader className="w-100">
                      <div className="d-flex justify-content-between align-items-center gap-2 w-100">
                        <div className="d-flex align-items-center gap-2">
                          <h6 className="fs-7 mb-0" style={{ color: 'var(--ui-color-primary, #2b7cd3)', opacity: '0.8' }}>
                            {obj} ({diagnosisCode[obj?.trim()] && diagnosisCode[obj?.trim()]}) <span style={{ cursor: 'pointer' }}> </span>
                          </h6>
                          {/* <CTooltip content={"Added initial symptoms during patient creation"}> */}
                          <CTooltip content={resolveTooltipContent(obj, info)}>
                            <Info size={16} />
                          </CTooltip>
                        </div>
                        <div>
                          <Pencil
                            size={16}
                            className="me-1 "
                            style={{ cursor: 'pointer' }}
                            onClick={(e) => {
                              e.stopPropagation()
                                ; (setEditDiagnosis(obj), setVisible(true))
                            }}
                          />
                          <Trash2
                            size={20}
                            strokeWidth={1.5}
                            style={{ cursor: 'pointer' }}
                            onClick={(e) => {
                              e.stopPropagation()
                                ; (setEditDiagnosis(obj), setDeleteVisible(true))
                            }}
                          />
                        </div>
                      </div>
                    </CAccordionHeader>
                    <CAccordionBody>
                      <div style={{ marginLeft: '1rem' }} className="px-2 py-3">
                        <div>
                          <b className="">POA </b>
                        </div>
                        <hr />

                        {loadingPoa ? (
                          <div className="d-flex justify-content-center align-items-center p-3">
                            <CSpinner color="primary" />
                          </div>
                        ) : (
                          <div>

                            {(() => {
                              const data = questionValue?.[obj] || []

                              if (!data.length) return null

                              return (
                                <>
                                  <PatientQuestionPoa noteStructureRef={noteStructureRef} diagnosisName={obj} questionValue={questionValue} />
                                  <div className="" style={{ marginBottom: '10pt' }}>
                                    {/* {freeTypeGlobal && <div>{freeTypeGlobal} </div>} */}

                                    {data.map((item, index) => (
                                      <div
                                        className="mt-1"
                                        key={index}
                                        style={{
                                          // textDecoration: (item?.type == 'Header' || item?.type == 'subHeader') ? 'underline'  : 'none' ,
                                          fontWeight: item?.type == 'Header' || item?.type == 'subHeader' ? 'bold' : '',
                                          fontSize: item?.type == 'Header' ? '15.5px' : '',
                                          gap: '5px',
                                          margin: 0,
                                        }}
                                      >
                                        {item?.freewayRemark && <div>{item?.freewayRemark} </div>}
                                        {
                                          <div className=" ">
                                            <p style={{ margin: 0 }}>
                                              <span
                                                style={{
                                                  fontWeight: 'bold',
                                                  textDecoration: item?.type === 'Header' ? 'underline' : 'none',
                                                  fontSize: item?.type === 'Header' ? '16.5px' : '15px',
                                                }}
                                              >
                                                {item?.type === 'Header' ? item.question : item?.type === 'subHeader' ? `${item.question} :` : `${item.question} - `}
                                              </span>
                                              <span className="p-0 text-black m-0" dangerouslySetInnerHTML={{ __html: item.answer }} />
                                            </p>
                                          </div>
                                        }
                                        {/* ${item.freeType && `<div >  <span style="font-weight:bold;font-size: 14px;">FreeType </span> - <span style="font-size: 13px;">${item?.freeType} <span>  </div>`}  */}
                                        {item?.freeType && (
                                          <div>
                                            {' '}
                                            <span style={{ fontWeight: 'bold', fontSize: '14px' }}> Free Type: </span> <span style={{ fontSize: '13px', fontWeight: 'normal' }} dangerouslySetInnerHTML={{ __html: item?.freeType }}></span>{' '}
                                          </div>
                                        )}
                                      </div>
                                      //                                    <div className="d-flex">
                                      //   <p style={{ margin: 0 }}>
                                      //     <span
                                      //       style={{
                                      //         fontWeight: 'bold',
                                      //         textDecoration:
                                      //           item?.type === 'Header' ? 'underline' : 'none',
                                      //         fontSize:
                                      //           item?.type === 'Header' ? '16.5px' : '15px',
                                      //       }}
                                      //     >
                                      //       {item?.type === 'Header'
                                      //         ? item.question
                                      //         : item?.type === 'subHeader'
                                      //         ? `${item.question} :`
                                      //         : `${item.question} - `}
                                      //     </span>

                                      //     <span
                                      //       style={{
                                      //         fontSize: '14px',
                                      //         color: '#fff',
                                      //       }}
                                      //       dangerouslySetInnerHTML={{
                                      //         __html: item?.answer
                                      //       }}
                                      //     />
                                      //   </p>
                                      // </div>
                                    ))}
                                  </div>
                                </>
                              )
                            })()}
                            {/* <hr /> */}
                          </div>
                        )}

                        <PatientHistoryofdiagnosis loading={loading}
                          setLoading={setLoading} diagnosisName={obj} noteStructureRef={noteStructureRef} />

                        <div className="mt-4">
                          <PatientRisk
                            saveTreatsShell={saveTreatsShell}
                            diagnosisAddedPinger={diagnosisAddedPinger}
                            showDataIfNoteIsFollowUp={showDataIfNoteIsFollowUp}
                            riskFactorWithKeyword={riskFactorWithKeyword}
                            hospitalRecords={hospitalRecords}
                            personalHistory={personalHistory}
                            setSelectedRisks={setSelectedRisks}
                            riskfactors={riskfactors}
                            selectedRisks={selectedRisks}
                            diagnosisName={obj}
                            noteStructureRef={noteStructureRef}
                            setRiskFactors={setRiskFactors}
                            patientData={patientData}
                            patientTreatments={patientTreatments}
                            noteID={noteID}
                            loading={loading}
                            setLoading={setLoading}
                          />
                        </div>
                        {obj == 'Falls' && (
                          <div className="mt-2">
                            <MorseScore saveTreatsShell={saveTreatsShell} showDataIfNoteIsFollowUp={showDataIfNoteIsFollowUp} noteStructureRef={noteStructureRef} diagnosisName={obj} scoreType={'MorseScore'} updateNoteStructure={updateNoteStructure} setNoteRefTrigger={setNoteRefTrigger} />
                          </div>
                        )}

                        {obj == 'Cognitive Communication Deficit' && (
                          <div className="mt-2">
                            <SelfCareAssessment showDataIfNoteIsFollowUp={showDataIfNoteIsFollowUp} diagnosisName={obj} noteStructureRef={noteStructureRef} />
                          </div>
                        )}
                        {obj == 'Cognitive Communication Deficit' && (
                          <div className="mt-2">
                            <MorseBimsScore showDataIfNoteIsFollowUp={showDataIfNoteIsFollowUp} noteStructureRef={noteStructureRef} diagnosisName={obj} scoreType={'BIMSScore'} updateNoteStructure={updateNoteStructure} />
                          </div>
                        )}

                        {obj == 'Falls' && (
                          <div className="mt-2">
                            <MobilityAssessment saveTreatsShell={saveTreatsShell} showDataIfNoteIsFollowUp={showDataIfNoteIsFollowUp} noteStructureRef={noteStructureRef} diagnosisName={obj} setNoteRefTrigger={setNoteRefTrigger} />
                          </div>
                        )}
                        <div className="mt-2">
                          <PatientAlerts showDataIfNoteIsFollowUp={showDataIfNoteIsFollowUp} noteStructureRef={noteStructureRef} diagnosisName={obj} setNoteRefTrigger={setNoteRefTrigger} />
                        </div>
                        <div className="mt-2">
                          <h7>
                            <b>Imaging</b>
                          </h7>
                          <hr />
                          <FinalNoteDisplayImaging showDataIfNoteIsFollowUp={showDataIfNoteIsFollowUp} MasterDiagnosisData={MasterDiagnosisData} noteStructureRef={noteStructureRef} imaging={imaging} imagingTypeList={imagingTypeList} diagnosisName={obj} />
                        </div>
                        <div className="mt-2">
                          <h7>
                            <b>Labs</b>
                          </h7>
                          <hr />
                          <LabDisplayComponent showDataIfNoteIsFollowUp={showDataIfNoteIsFollowUp} noteStructureRef={noteStructureRef} diagnosisAddedPinger={diagnosisAddedPinger} diagnosis={obj} allLabs={allLabs} labEntry={diagnosisLabMap[obj]} />
                        </div>
                        <div>
                          <PatientIncidet saveTreatsShell={saveTreatsShell} addedNewIncident={addedNewIncident} isAllotedToProvider={isAllotedToProvider} diagnosisName={obj} noteStructureRef={noteStructureRef} />
                        </div>
                        <div>
                          <PatientDifferentialDiagnosis
                            saveTreatsShell={saveTreatsShell}
                            isAllotedToProvider={isAllotedToProvider}
                            diagnosisName={obj}
                            patientDifferentialDiagnosis={patientDifferentialDiagnosis}
                            selectedDifferentialDiagnosis={selectedDifferentialDiagnosis}
                            setSelectedDifferentialDiagnosis={setSelectedDifferentialDiagnosis}
                            noteStructureRef={noteStructureRef}
                            loading={loading}
                            setLoading={setLoading}
                          />
                        </div>
                        <div className="mt-2">
                          {obj === 'Falls' ? (
                            <FallsAssessment patientID={patientID} saveTreatsShell={saveTreatsShell} isAllotedToProvider={isAllotedToProvider} showDataIfNoteIsFollowUp={showDataIfNoteIsFollowUp} noteStructureRef={noteStructureRef} diagnosisName={obj} noteRefTrigger={noteRefTrigger} />
                          ) : (
                            <AsseseementFinalNote
                              saveTreatsShell={saveTreatsShell}
                              patientID={patientID}
                              isAllotedToProvider={isAllotedToProvider}
                              showDataIfNoteIsFollowUp={showDataIfNoteIsFollowUp}
                              MasterDiagnosisData={MasterDiagnosisData}
                              newImagingAdded={newImagingAdded}
                              newLabsAdded={newLabsAdded}
                              newmedsAdded={newmedsAdded}
                              patientTreatments={patientTreatments}
                              noteStructureRef={noteStructureRef}
                              masterMedications={masterMedications}
                              medicationList={medication}
                              diagnosisAddedPinger={diagnosisAddedPinger}
                              allLabs={allLabs}
                              labEntry={diagnosisLabMap[obj]}
                              imaging={imaging}
                              medsRemarks={getDiagnosisMedicationInRisk(obj)}
                              imagingTypeList={imagingTypeList}
                              diagnosisName={obj}
                              noteID={noteID}
                              loading={loading}
                              setLoading={setLoading}
                            />
                          )}

                          {/* {obj === 'Falls' ? <FallsAssessment noteStructureRef={noteStructureRef} diagnosisName={obj} /> : <AsseseementFinalNote MasterDiagnosisData={MasterDiagnosisData} newImagingAdded={newImagingAdded} newLabsAdded={newLabsAdded} newmedsAdded={newmedsAdded} patientTreatments={patientTreatments} noteStructureRef={noteStructureRef} masterMedications={masterMedications} medicationList={medication} diagnosisAddedPinger={diagnosisAddedPinger} allLabs={allLabs} labEntry={diagnosisLabMap[obj]} imaging={imaging} medsRemarks={getDiagnosisMedicationInRisk(obj)} imagingTypeList={imagingTypeList} diagnosisName={obj} noteID={noteID} />} */}
                        </div>

                        {/* <div className='mt-2 '>
                                            <h7><b>Meds</b></h7>
                                            <hr />
                                            <NoteMedicationsDisplay noteStructureRef={noteStructureRef} medication={medication} masterMedications={masterMedications} diagnosisName={obj} />
                                    </div> */}

                        <div className="mt-2">
                          <PatientTreatmentsPlans
                            saveTreatsShell={saveTreatsShell}
                            isAllotedToProvider={isAllotedToProvider}
                            patientID={patientID}
                            allTreamentStatements={allTreamentStatements}
                            setAllTreatmentStatements={setAllTreatmentStatements}
                            showDataIfNoteIsFollowUp={showDataIfNoteIsFollowUp}
                            medicationList={medication}
                            masterMedications={masterMedications}
                            noteStructureRef={noteStructureRef}
                            diagnosisName={obj}
                            patientTreatments={patientTreatments}
                            allLabs={allLabs}
                            noteID={noteID}
                            loading={loading}
                            setLoading={setLoading}
                          />
                        </div>
                      </div>
                    </CAccordionBody>
                  </CAccordionItem>
                )
              })}
          </CAccordion>
        </div>

        <CModal visible={visible} onClose={() => setVisible(false)}>
          <CModalHeader>
            <CModalTitle>Edit Diagnosis</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <div>
              <div className="mb-3  mx-auto" style={{ width: '75%' }}>
                <CFormLabel style={{ fontSize: '16px', fontWeight: '500' }}>Select Diagnosis</CFormLabel>
                <MultiSelect
                  value={selectedDiagnosis}
                  onChange={(e) => {
                    setSelectedDiagnosis(e)
                  }}
                  options={diagnosisOptions}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select or create Diagnosis"
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      borderColor: '#ced4da',
                      boxShadow: 'none',
                      '&:hover': {
                        borderColor: '#80bdff',
                      },
                    }),
                  }}
                />
              </div>
            </div>
          </CModalBody>
          <CModalFooter>
            <CButton color="secondary" variant="outline" onClick={() => setVisible(false)}>
              Close
            </CButton>
            <CButton color="primary" variant="outline" onClick={handleSaveDiagnosis}>
              Save{' '}
            </CButton>
          </CModalFooter>
        </CModal>
        <CModal backdrop="static" visible={deleteVisible} onClose={() => setDeleteVisible(null)}>
          <CModalHeader>
            <CModalTitle>Warning</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
          </CModalBody>
          <hr className="p-0 m-0" />
          <CModalFooter className="p-3 m-0">
            <CButton
              onClick={() => {
                setDeleteVisible(null)
              }}
              variant="outline"
              color="secondary"
            >
              Close
            </CButton>
            <CButton
              variant="outline"
              onClick={() => {
                handleDeleteDiagnosis()
              }}
              color="danger"
            >
              Delete
            </CButton>
          </CModalFooter>
        </CModal>
      </div>
    </div>
  )
}

export default Note
